module.exports = __webpack_public_path__ + "img/sliders-simple.6f06aed8.svg";